// React
import React, { useCallback, useContext, useEffect, useState } from "react";
// React

// CSS
import styles from "./DeviceManager.module.css";
// CSS

// Icons
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
// Icons

// Images
import { deviceManagerIMG } from "../../Images/images";
// Images

// Contexts
import { UserTokenContext } from "../../Contexts/userToken";
import { getUserDevicesService } from "../../Services/DeviceManager/get/getUserDevicesService";
import { I_DeviceData } from "../../Models/interfaces";
import DeviceItem from "./DeviceItem/DeviceItem";
import Spinner from "../../Utils/Spinner/Spinner";
// Contexts

type DeviceManagerProps = {
  setIsNeedFullScreen: React.Dispatch<React.SetStateAction<boolean>>;
};
const DeviceManager: React.FunctionComponent<DeviceManagerProps> = ({
  setIsNeedFullScreen,
}) => {
  const navigate = useNavigate();
  const userToken = useContext(UserTokenContext);

  const [isPending, setIsPending] = useState<boolean>(true);
  const [isError, setIsError] = useState<boolean>(false);

  const [userDevices, setUserDevices] = useState<{
    data: I_DeviceData[];
    deviceLimitationCount: number;
    activeDeviceCount: number;
  }>({
    activeDeviceCount: 1,
    data: [],
    deviceLimitationCount: 1,
  });

  const dataFetcher = useCallback(() => {
    setIsPending(true);
    getUserDevicesService(userToken)
      .then((res) => {
        setUserDevices(res.data);
      })
      .catch((err) => {
        console.log(err);
        setIsError(true);
      })
      .finally(() => {
        setIsPending(false);
      });
  }, [userToken]);

  useEffect(() => {
    setIsNeedFullScreen(true);
    return () => {
      setIsNeedFullScreen(false);
    };
  }, [setIsNeedFullScreen]);

  useEffect(() => {
    dataFetcher();
  }, [dataFetcher]);

  return (
    <div
      className={`${styles.deviceManageContainer}  overflow-y-scroll pb-[10vh]`}
    >
      <div
        className={`${styles.topItems} flex flex-row-reverse items-center justify-between w-full p-2 relative`}
      >
        <BiArrowBack
          className="absolute top-1/4 left-3 text-2xl"
          onClick={() => {
            navigate(-1);
          }}
        />
        <img src={deviceManagerIMG} alt="" className="w-5/12" />
        <div className={`${styles.content} flex flex-col items-end w-7/12`}>
          <h1 className="text-xl">دستگاه های فعال</h1>
          <p
            className="w-full text-right text-xs"
            style={{
              width: "calc(100% - 2rem)",
            }}
          >
            در این صفحه شما میتوانید لیستی از دستگاه های فعال که با حساب کاربری
            شما وارد شده اند را مشاهده کرده و درصورت نیاز اقدام به غیرفعال سازی
            آنها نمایید .
          </p>
        </div>
      </div>

      {isPending && !isError ? (
        <div className="w-full flex flex-col items-center justify-center bg-purple-500 py-2">
          <p>در حال بارگیری</p>
          <Spinner className="mt-2" />
        </div>
      ) : null}

      {!isPending && isError ? (
        <button
          className="w-full flex flex-row items-center justify-center"
          onClick={dataFetcher}
        >
          تلاش مجدد
        </button>
      ) : null}

      {!isPending && !isError ? (
        <>
          <p
            className="w-full flex flex-row items-center justify-end  pr-4 pb-2 text-blue-600 text-xs"
            style={{
              borderBottom: "1px solid gray",
            }}
          >
            محدودیت تعداد دستگاه : {userDevices.deviceLimitationCount}
          </p>
          {userDevices.data.map((item) => (
            <DeviceItem data={item} reloader={dataFetcher} />
          ))}
        </>
      ) : null}
    </div>
  );
};

export default DeviceManager;
